import React from 'react';

/**
 * LoadingSkeleton — Reusable skeleton loader.
 * Consistent border-radius (rounded-2xl) and animation.
 *
 * @param {number} count - Number of skeleton blocks
 * @param {'card'|'row'|'stat'} variant - Shape preset
 * @param {number} cols - Grid columns (for stat/card variant)
 */
const LoadingSkeleton = ({ count = 3, variant = 'card', cols = 1 }) => {
  const heightMap = {
    card: 'h-48',
    row: 'h-16',
    stat: 'h-28',
  };

  const h = heightMap[variant] || 'h-48';
  const gridCls = cols > 1 ? `grid grid-cols-1 md:grid-cols-${cols} gap-6` : 'space-y-4';

  return (
    <div className={gridCls} role="status" aria-label="Loading">
      {Array.from({ length: count }).map((_, i) => (
        <div
          key={i}
          className={`${h} rounded-2xl animate-pulse bg-slate-100`}
        />
      ))}
      <span className="sr-only">Loading...</span>
    </div>
  );
};

export default LoadingSkeleton;
